import { render, staticRenderFns } from "./control-textbox.vue?vue&type=template&id=bb0bb5d4&scoped=true&"
import script from "./control-textbox.vue?vue&type=script&lang=js&"
export * from "./control-textbox.vue?vue&type=script&lang=js&"
import style0 from "./control-textbox.vue?vue&type=style&index=0&id=bb0bb5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0bb5d4",
  null
  
)

export default component.exports